// Este componente esta siendo migrado al nuevo repositorio de https://github.com/melisource/fury_vpp-frontend-components, no modificar, ante cualquier duda mandar mensaje a Mcalderon

import { createBrowserHistory, createMemoryHistory } from 'history';
import { canUseDOM } from './dom-utils';

const factory = config => (canUseDOM ? createBrowserHistory(config) : createMemoryHistory(config));
const createHistory = config => factory(config);

export default createHistory;
